import {inject, Injectable} from '@angular/core';
import {
    HttpClient,
    HttpEvent,
    HttpHandler, HttpHeaders,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import {Router} from '@angular/router';
import {tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {TokenStorage} from './token.storage';
import {NgxSpinnerService} from 'ngx-spinner';
import {NotifierService} from '@services/notifier.service';
import {AppConfig} from '../app.config';
import {HttpCacheService} from '@services/http-cache.service';
import {HttpOptionsService} from '@services/http-options.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
    /** Карта кеширования запросов */
    readonly #cache: HttpCacheService = inject(HttpCacheService);
    /**
     * Конструктор
     * @param {HttpClient} http объект запросов
     * @param {AppConfig} _config сервис получения конфигураций
     * @param {TokenStorage} token класс работы с токеном
     * @param {NgxSpinnerService} spinner прелоадер
     * @param {NotifierService} notifier сервис всплывающих сообщений
     */
    constructor(public http: HttpClient,
                public _config: AppConfig,
                public token: TokenStorage,
                private spinner: NgxSpinnerService,
                private notifier: NotifierService,
                public router: Router) {
    }

    /** Сервис параметров http-запроса */
    #httpOptions: HttpOptionsService = inject(HttpOptionsService);

    /**
     * Отслеживание запросов
     * @param req запрос
     * @param next обработчик запроса
     */
    intercept<T>(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const checkAuth = (event) => {
            if (event instanceof HttpResponse) {
                if (event.body && event.body && event.body.is_not_auth) {
                    this.signOut();
                }
            }
        };

        if (req.headers.has('use-cache')) {
            // Проверяем, является ли запрос POST-запросом
            const cacheKey = req.urlWithParams + JSON.stringify(req.body);
            const cachedResponse = this.#cache.get(cacheKey);
            if (cachedResponse) {
                // Если есть кэшированный ответ, возвращаем его
                return of(cachedResponse.clone());
            }

            // Возвращаем запрос и сохраняем ответ в кэше
            return next.handle(req).pipe(
                tap(checkAuth),
                tap(event => {
                    if (event instanceof HttpResponse) {
                        this.#cache.set(cacheKey, event.clone());
                    }
                })
            );
        }

        return next.handle(req).pipe(
            tap(checkAuth)
        );
    }

    /** Выход из системы */
    private signOut() {
        this.spinner.show();
        this.#cache.clear();
        this.logout().toPromise().then(() => {
            this.spinner.hide();
            this.token.signOut();
            this.router.navigate(['/']);
        }).catch(() => {
            this.spinner.hide();
            this.token.signOut();
            this.router.navigate(['/']);
        });
    }

    /**
     * Выход из системы
     */
    public logout(): Observable<any> {
        return this.http.post<any>(this._config.url + '/auth/logout', {}, this.#httpOptions);
    }
}
